import React from "react";

// Root and main routes
export const Root = React.lazy(() => import("./Root"));
export const LeaderboardPage = React.lazy(() =>
  import("./LeaderboardPage").then((m) => ({ default: m.LeaderboardPage })),
);
export const ProfilePage = React.lazy(() =>
  import("./ProfilePage").then((m) => ({ default: m.ProfilePage })),
);
export const SessionPage = React.lazy(() =>
  import("./SessionPage").then((m) => ({ default: m.SessionPage })),
);
export const VenuesPage = React.lazy(() =>
  import("./VenuesPage").then((m) => ({ default: m.VenuesPage })),
);
export const VenuePage = React.lazy(() =>
  import("./VenuePage").then((m) => ({ default: m.VenuePage })),
);
export const ThumbOrCumPage = React.lazy(() =>
  import("./ThumbOrCumPage").then((m) => ({ default: m.ThumbOrCumPage })),
);

// Chat routes
export const ChatRoutes = React.lazy(() =>
  import("./chat/ChatRoutes").then((m) => ({ default: m.ChatRoutes })),
);
export const ChatGroupPage = React.lazy(() =>
  import("./chat/ChatGroupPage").then((m) => ({ default: m.ChatGroupPage })),
);
export const ChatEmptyState = React.lazy(() =>
  import("./chat/ChatEmptyState").then((m) => ({ default: m.ChatEmptyState })),
);

// Admin routes
export const AdminRoutes = React.lazy(() =>
  import("./admin/AdminRoutes").then((m) => ({ default: m.AdminRoutes })),
);
export const ManageBroBotPage = React.lazy(() =>
  import("./admin/ManageBroBotPage").then((m) => ({ default: m.ManageBroBotPage })),
);
export const ManageProfilesPage = React.lazy(() =>
  import("./admin/ManageProfilesPage").then((m) => ({
    default: m.ManageProfilesPage,
  })),
);
export const ManageToolsPage = React.lazy(() =>
  import("./admin/ManageToolsPage").then((m) => ({
    default: m.ManageToolsPage,
  })),
);
export const ManageVenuesPage = React.lazy(() =>
  import("./admin/ManageVenuesPage").then((m) => ({
    default: m.ManageVenuesPage,
  })),
);

// Leaderboard routes
export const LeaderboardMonthly = React.lazy(() =>
  import("./leaderboards/LeaderboardsMonthly").then((m) => ({
    default: m.LeaderboardMonthly,
  })),
);
export const LeaderboardRoutes = React.lazy(() =>
  import("./leaderboards/LeaderboardsRoutes").then((m) => ({
    default: m.LeaderboardRoutes,
  })),
);
export const LeaderboardYearly = React.lazy(() =>
  import("./leaderboards/LeaderboardsYearly").then((m) => ({
    default: m.LeaderboardYearly,
  })),
);

export const LeaderboardWeekly = React.lazy(() =>
  import("./leaderboards/LeaderboardsWeekly").then((m) => ({
    default: m.LeaderboardWeekly,
  })),
);

// Morsal routes
export const MorsalRoutes = React.lazy(() =>
  import("./morsals/MorsalRoutes").then((m) => ({ default: m.MorsalRoutes })),
);
export const MorsalsPage = React.lazy(() =>
  import("./morsals/MorsalsPage").then((m) => ({ default: m.MorsalsPage })),
);
export const NewMorsalPage = React.lazy(() =>
  import("./morsals/NewMorsalPage").then((m) => ({ default: m.NewMorsalPage })),
);

// Quote routes
export const QuoteRouletteRoutes = React.lazy(() =>
  import("./quotes/QuoteRouletteRoutes").then((m) => ({
    default: m.QuoteRouletteRoutes,
  })),
);

export const QuoteRoulettePage = React.lazy(() =>
  import("./quotes/QuoteRoulettePage").then((m) => ({
    default: m.QuoteRoulettePage,
  })),
);
export const QuoteRouletteLeaderboard = React.lazy(() =>
  import("./quotes/QuoteRouletteLeaderboard").then((m) => ({
    default: m.QuoteRouletteLeaderboard,
  })),
);

// Shop routes
export const InventoryPage = React.lazy(() =>
  import("./shop/InventoryPage").then((m) => ({ default: m.InventoryPage })),
);
export const LottoDrawPage = React.lazy(() =>
  import("./LottoDrawPage").then((m) => ({ default: m.LottoDrawPage })),
);
export const ShopPage = React.lazy(() =>
  import("./shop/ShopPage").then((m) => ({ default: m.ShopPage })),
);
export const ShopRoutes = React.lazy(() =>
  import("./shop/ShopRoutes").then((m) => ({ default: m.ShopRoutes })),
);

// Sweepstake routes
export const SweepstakePage = React.lazy(() =>
  import("./sweepstakes/SweepstakePage").then((m) => ({
    default: m.SweepstakePage,
  })),
);
export const SweepstakesPage = React.lazy(() =>
  import("./sweepstakes/SweepstakesPage").then((m) => ({
    default: m.SweepstakesPage,
  })),
);
